import { Typography, BlueBirdTheme } from "@kitbird/core";
import LoadingLottie from "./LoadingLottie";
import BaseLoadingContainerDiv from "./Loading.style";

const {
  black,
  gray,
} = BlueBirdTheme.colors;

interface IBaseLoadingProps {
  loadingTitle?: string;
  loadingDescription?: string;
}

const BaseLoading = ({
  loadingTitle,
  loadingDescription,
}: IBaseLoadingProps) => (
  <BaseLoadingContainerDiv data-testid="base-loading-container">
    <LoadingLottie />
    {
      loadingTitle && (
        <Typography level={3} color={black} fontWeight="medium">
          {loadingTitle}
        </Typography>
      )
    }
    {
      loadingDescription && (
        <Typography level={4} color={gray.subtitle}>
          {loadingDescription}
        </Typography>
      )
    }
  </BaseLoadingContainerDiv>
);

export default BaseLoading;
